










































































































































import {Vue, Component} from "vue-property-decorator";
import {Instance, User} from "../../api/config/Users";
import * as Resource from "../../api/Resource";
import {TogglePayload} from "../../store/modules/app/state";
import {mapActions} from "vuex";
import {PaymentProvider} from "../../api/config/PaymentProvider";

@Component({
  methods: {
    ...mapActions("app", ["toggleGlobalSnackBar"]),
  },
})
export default class Users extends Vue {
  search = "";
  loadingUses = false;
  deletingItemPending = false;
  deleteConfirmationDialog = false;
  itemToDelete: PaymentProvider | null = null;
  toggleGlobalSnackBar!: (payload: TogglePayload) => void;
  headers = [
    { divider: true, text: "Icon Url", value: "iconUrl"},
    { divider: true, text: "Name", value: "name", align: "start"},
    { divider: true, text: "Identifier", value: "identifier"},
    { divider: true, text: "Order/s", value: "order"},
    { divider: true, text: "Active For One Time", value: "activeForOneTime"},
    { divider: true, text: "Active For Subscription", value: "activeForSubscription"},
    { divider: true, text: "Should Reward Points", value: "shouldRewardPoints"},
    { divider: true, text: "Created At", value: "createdAt"},
    { divider: true, text: "Actions", value: "actions", sortable: false},
  ];
  users: PaymentProvider[] = [];

  async fetchUsers() {
    this.loadingUses = true;
    const res = await Resource.paymentProviders.getPaymentProviders().get();
    this.users = res?.data || [];
    this.loadingUses = false;
  }

  getBoolenColor(isVerified: boolean) {
    return isVerified ? "green" : "red";
  }

  created() {
    this.fetchUsers();
  }

  setItemToDelete(item: PaymentProvider) {
    this.itemToDelete = item;
    this.deleteConfirmationDialog = true;
  }

  updateUser(item: PaymentProvider) {
    this.$router.push({
      name: `Update PaymentProvider`,
      params: {
        id: item.name,
        // @ts-ignore
        payload: item,
      },
    });
  }

  async deleteItem() {
    if (this.itemToDelete) {
      this.deleteConfirmationDialog = false;
      this.deletingItemPending = true;
      try {
        const res = await Resource.paymentProviders
          .deletePaymentProvider(this.itemToDelete.id || "")
          .pipe();
        this.toggleGlobalSnackBar({
          show: true,
          type: "error",
          text: "Payment Provider deleted successfully!",
        });
        this.deletingItemPending = false;
        this.fetchUsers();
      } catch (e) {
        console.log(e);
        this.toggleGlobalSnackBar({
          show: true,
          type: "error",
          text: e.message || "Unknown error pccured please try again!",
        });
      }
    }
  }
}
